module.exports = __webpack_public_path__ + "img/qr-code-green.8df53f11.png";